<template>
    <vx-expandable-card>
        <template v-slot:header>
            <vx-badge v-if="badgeData" :color="badgeData.color">
                <font-awesome-icon widthAuto :icon="badgeData.icon" />
                {{ badgeData.label }}
            </vx-badge>
            <div v-else class="text-xl">
                {{ group.name }}
            </div>
        </template>
        <template v-slot:content>
            <div v-if="group.features.length > 0" class="flex flex-col gap-4">
                <kiosk-team-feature
                    v-for="(feature, index) in group.features"
                    :key="group.features[index].id"
                    v-model="group.features[index]"
                    :teamId="props.teamId"
                >
                </kiosk-team-feature>
            </div>
            <div v-else>No new features at this time. Check back later!</div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { faFlask, faSkullCrossbones, faVialVirus } from '@fortawesome/pro-solid-svg-icons';
import { VxBadge, VxExpandableCard } from '@voxie/frontend-components';
import KioskTeamFeature from './KioskTeamFeature.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';

const group = defineModel();
const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const badgeData = computed(() => {
    switch (group.value.type) {
        case 'beta':
            return {
                icon: faFlask,
                color: 'amber',
                label: 'Beta',
            };
        case 'alpha':
            return {
                icon: faVialVirus,
                color: 'fuchsia',
                label: 'Alpha',
            };
        case 'internal':
            return {
                icon: faSkullCrossbones,
                color: 'rose',
                label: 'Internal',
            };
        default:
            return null;
    }
});
</script>
